export const fsCheckboxDefaults = {
    checked: false,
    compact: false,
    disabled: false,
    error: false,
    indeterminate: false,
    name: '',
    required: false,
    value: ''
};
export const fsCheckboxFieldsetDefaults = {
    compact: false,
    disabled: false
};
//# sourceMappingURL=IFsCheckbox.js.map